// imports
import { useSelector } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import Map from '../molecules/map';
import { IMap } from '../common/types';
import GameLayout from '../layouts/game';
import { selectConfig } from '../repositories/store/slices';

// exports
export default function Game(): JSX.Element {
  // hooks configuration
  const mapRef = useRef<IMap>(null);
  const prevRegion = useRef<string>('');
  const { world } = useSelector(selectConfig);
  const [regionId, setRegionId] = useState('');
  const [backBtnText, setBackBtnText] = useState(world.name);

  useEffect(() => {
    if (regionId) { mapRef.current!.zoomToElement(regionId); }
    const handleDisplayScaleChange = (): void => {
      if (regionId) {
        mapRef.current!.zoomToElement(regionId);
      } else { mapRef.current!.centerView(); }
    };
    window.addEventListener('resize', handleDisplayScaleChange);
    return () => { window.removeEventListener('resize', handleDisplayScaleChange); };
  }, [regionId]);

  const backBtnClickedCB = regionId ? () => {
    if (prevRegion.current) {
      prevRegion.current = '';
      setBackBtnText(world.name);
      document.getElementById('modal-close')?.click(); // TODO: Need to be removed in latest quest implementation
    } else {
      setRegionId('');
      mapRef.current!.zoomOut();
    }
  } : undefined;

  // render
  return (
    <GameLayout backBtnClickedCB={backBtnClickedCB} backButtonText={backBtnText}>
      <Map
        ref={mapRef}
        regionClickedCB={(pRegionId) => setRegionId(pRegionId)}
        pinClickedCB={(regionName) => {
          prevRegion.current = regionName;
          setBackBtnText(regionName);
        }}
      />
    </GameLayout>
  );
}
